import React from "react";
import AboutSupportImage from "../../assets/images/about-us/support.png";
import AboutTimeImage from "../../assets/images/about-us/saving-time.png";
import PostSalesImage from "../../assets/images/about-us/pre-sales.png";
import PowerResearchImage from "../../assets/images/about-us/power-their-research.png";

const Aim = () => {
  const aims = [
    {
      src: AboutSupportImage,
      alt: "Streamline Hospitality Workflows",
      title: "Streamline Hospitality Workflows",
      desc: "We support hotel and travel businesses by simplifying complex sales, marketing, and guest engagement processes—saving time, reducing costs, and boosting operational efficiency.",
      iconBg: "#EEF2FF",
      iconBorder: "#C7D2FE",
    },
    {
      src: AboutTimeImage,
      alt: "Enable End-to-End Sales Support",
      title: "Enable End-to-End Sales Support",
      desc: "From presales to post-stay CRM, BeyondLeadz empowers your teams across the entire customer journey—driving personalized outreach, faster conversions, and stronger guest loyalty.",
      iconBg: "#FFF1F2",
      iconBorder: "#FECDD3",
    },
    {
      src: PostSalesImage,
      alt: "Fuel Smart Decisions with Data",
      title: "Fuel Smart Decisions with Data",
      desc: "Our platform enhances your research and knowledge engine with real-time data, guest behavior analytics, and actionable intelligence—so every decision is data-backed and guest-centric.",
      iconBg: "#FDF4FF",
      iconBorder: "#F0ABFC",
    },
    {
      src: PowerResearchImage,
      alt: "Unlock Revenue Opportunities",
      title: "Unlock Revenue Opportunities",
      desc: "With AI-driven insights, we help you identify, target, and convert high-potential leads, turning new opportunities into long-term guests and partnerships.",
      iconBg: "#FEFCE8",
      iconBorder: "#FDE047",
    }
  ];

  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/40 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Title */}
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Our Aim to
          </h2>
        </div>

        {/* Aim Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-8">
          {aims.map((aim, index) => (
            <div
              key={index}
              className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-text-center tw-flex tw-flex-col"
            >
              {/* Ghost watermark icon in background */}
              <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none">
                <img
                  src={aim.src}
                  alt=""
                  aria-hidden="true"
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>

              {/* Icon box — color matches icon's own palette */}
              <div
                className="tw-w-14 tw-h-14 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4 tw-flex-shrink-0"
                style={{ backgroundColor: aim.iconBg, border: `1.5px solid ${aim.iconBorder}` }}
              >
                <img
                  src={aim.src}
                  alt={aim.alt}
                  className="tw-w-8 tw-h-8 tw-object-contain"
                />
              </div>

              {/* Text */}
              <h3 className="tw-text-base tw-font-extrabold tw-text-slate-800 tw-mb-3">
                {aim.title}
              </h3>
              <p className="tw-text-xs tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                {aim.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Aim;
